





















































import useImageGalleryModal from "@/composables/v3/useImageGalleryModal";
import i18n from "@/libs/i18n";
import { useChannelsStore } from "@/store/useChannelsStore";
import { displayFileName, downloadFile, getFullPath } from "@/utils/assets";
import { resolveContentTypeIcon } from "@/utils/chats";
import { textIsOnlyEmoji } from "@/utils/v3/chat.utils";
import { AttachmentEntryDto, EntryDirection } from "@saysimple-platform/dtos";
import { computed, defineComponent, PropType, Ref, ref } from "@vue/composition-api";
import { BButton, BEmbed, BImg, BImgLazy, BLink } from "bootstrap-vue";
import { useToast } from "vue-toastification/composition";
import ParsedMessage from "./parsedMessage.vue";

export default defineComponent({
    components: {
        ParsedMessage,
        BImg,
        BImgLazy,
        BButton,
        BEmbed,
        BLink,
    },
    props: {
        entry: {
            type: Object as PropType<AttachmentEntryDto>,
            required: true,
        },
        groupDirection: {
            type: String as PropType<EntryDirection>,
            required: false,
        },
    },
    setup(props) {
        const channelsStore = useChannelsStore();
        const { openImageGalleryModal } = useImageGalleryModal();

        const audioError: Ref<boolean> = ref(false);
        const toast = useToast();

        const isOnlyEmoji = computed((): boolean => textIsOnlyEmoji(props.entry.message));
        return {
            channelsStore,
            getFullPath,
            localDownloadFile: (asset: Record<string, string>) =>
                downloadFile(asset).catch(() => toast.error(i18n.t("toast.read.error"))),
            audioError,
            onAudioError: () => (audioError.value = true),
            resolveContentTypeIcon,
            isOnlyEmoji,
            displayFileName,
            openImageGalleryModal,
        };
    },
});
